// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f6a4c6040baeb119b888","883":"58db662c7d004a8b25dc"}[chunkId] + ".js";
};